import { Component, OnInit } from '@angular/core';
import { CartService } from '../../cart/cart.service';
import { SharedService } from '../../shared.service';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { SiteConfig } from 'app/interfaces/SiteConfig';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent implements OnInit {
  public products = null;
  public totalPrice: Number = 0;
  public priceLotteryOnly: Number = 0;
  public defaultTotalPrice: Number = 0;
  public serviceFee: Number = 0;
  public pension: Boolean = false;
  public couponCode = null;
  public discount = null;
  public backPay = null;
  public pensionRate = null;
  public lottery = null;
  public lotteryNumber = null;
  public lotteryStartDate = null;
  public lotteryEndDate = null;
  public showBackPay: Boolean = false;
  public environment: string;
  public isConfirmation: boolean = false;
  public siteConfig: SiteConfig = this.sharedService.getSiteConfig();
  public showCartPage: Boolean = this.siteConfig.showCartPage;

  constructor(
    private cartService: CartService,
    private sharedService: SharedService,
    private router: Router
  ) {
    this.pension =
      this.sharedService.getLotterySource() === 'pension' ? true : false;
    this.environment = this.sharedService.getEnvironment();
  }

  ngOnInit() {
    const startDate = moment(this.cartService.getLottery().start);
    const endDate = moment(this.cartService.getLottery().end);
    const backPayStartDate = startDate.clone().add(20, 'days');

    this.isConfirmation = this.router.url === '/bestellen/bestaetigung';

    this.products = this.cartService.getProducts();
    this.totalPrice =
      this.cartService.getTotalPrice() < 0
        ? 0
        : this.cartService.getTotalPrice();
    this.priceLotteryOnly = this.cartService.getLotteryOnlyPrice();
    this.defaultTotalPrice = this.cartService.getTotalPriceWithoutDiscount();
    this.serviceFee = this.cartService.getServiceFee();
    this.backPay = this.cartService.getBackPay();
    this.discount = this.cartService.getDiscount();
    this.couponCode = this.cartService.getCouponCode();
    this.pensionRate = this.cartService.getPensionRate();
    this.lottery = this.cartService.getLottery();
    this.lotteryNumber = this.cartService.getLotteryNumber();
    this.lotteryStartDate = startDate.format('DD.MM.YYYY');
    this.lotteryEndDate = endDate.format('DD.MM.YYYY');
    this.showBackPay =
      !this.pension && this.backPay > 0 && moment().isAfter(backPayStartDate)
        ? true
        : false;

    /*
     * Subscribes the EventEmitter from
     * CartService and updates local properties
     * if values have changed.
     */
    this.cartService.cartUpdated.subscribe((calulcatedProduct) => {
      this.totalPrice =
        calulcatedProduct.price + calulcatedProduct.lottery.serviceFee < 0
          ? 0
          : calulcatedProduct.price + calulcatedProduct.lottery.serviceFee;
      this.priceLotteryOnly = calulcatedProduct.priceLotteryOnly;
      this.couponCode = calulcatedProduct.couponCode;
      this.discount = calulcatedProduct.discount;
      this.backPay = calulcatedProduct.backPay;
      this.defaultTotalPrice = calulcatedProduct.defaultTotalPrice;
      this.pensionRate = calulcatedProduct.pensionRate;
      this.showBackPay =
        !this.pension && this.backPay > 0 && moment().isAfter(backPayStartDate)
          ? true
          : false;
    });
  }

  getTooltipText() {
    const text = `Die ${this.lotteryNumber}. Lotterie hat bereits am ${this.lotteryStartDate} begonnen. Sie haben noch die Möglichkeit in die laufende Lotterie einzusteigen. Für bereits abgelaufene Klassen müssen Sie Ihren Einsatz nachentrichten. Dies gilt nicht für die Joker Spiele.`;
    return text;
  }

  public getProductName(productName: string): string {
    let productDisplayName: string;

    if (productName === 'SKL TRAUM-JOKER') {
      productDisplayName =
        this.sharedService.getSessionStorage('jokerType') === 'Weihnachts'
          ? 'SKL WEIHNACHTS-JOKER'
          : productName;
    } else {
      productDisplayName = productName;
    }

    return productDisplayName;
  }
}
